import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressComponent } from './progress.component';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  declarations: [ProgressComponent],
  exports: [ProgressComponent],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    MatProgressBarModule,
    TranslateModule,
    MatRippleModule,
  ],
})
export class ProgressModule {}
